<app-navbar [title]="'Dokumenty'"> </app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-vehicles-documents-filters
	userFilters="vehiclesDocuments"
	[vehicleDocumentsTypes]="parameters.documentsType"
	[statuses]="parameters.statuses"
	[types]="parameters.types"
	(selected)="filtersSelected($event)"
></app-vehicles-documents-filters>

<app-dynamic-table
	[elements]="vehiclesDocuments"
	[tableRows]="tableRows"
	module="vehicles"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
<!-- <div class="card">
	<div class="card-body">
		<form (submit)="setNumberOfResults()">
			<div class="form-inline">
				<label for="numberOfResults">Ilość wyników na stronie: </label>
				<select class="form-control" id="numberOfResults" name="countLimit" [(ngModel)]="countLimit">
					<option>50</option>
					<option>200</option>
					<option>500</option>
				</select>
				<button type="submit" class="btn btn-primary ml-2">pokaż</button>
			</div>
		</form>
	</div>
</div> -->
